import React from 'react';

// Press / Media Coverage Section
const PressSection = ({ data }) => {
  const { heading = 'In the Press', items = [], background_color } = data || {};
  
  const bgStyle = background_color ? { backgroundColor: background_color } : {};
  
  if (!items || items.length === 0) {
    return null;
  }
  
  return (
    <section className="py-16 px-4" style={bgStyle}>
      <div className="max-w-6xl mx-auto">
        {heading && (
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            {heading}
          </h2>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, index) => (
            <a
              key={index}
              href={item.url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 border border-gray-100"
            >
              {item.logo && (
                <img
                  src={item.logo}
                  alt={item.source || 'Press'}
                  className="h-8 w-auto object-contain mb-4 grayscale"
                />
              )}
              {item.source && !item.logo && (
                <p className="text-sm font-medium text-gray-500 uppercase tracking-wide mb-2">
                  {item.source}
                </p>
              )}
              {item.title && (
                <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
              )}
              {item.excerpt && (
                <p className="text-gray-600 text-sm line-clamp-3">
                  {item.excerpt}
                </p>
              )}
              {item.date && (
                <p className="text-xs text-gray-400 mt-3">
                  {new Date(item.date).toLocaleDateString()}
                </p>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PressSection;
